
function openWindow() {
    window.open("http://localhost:4202/modeloDocumentos", "minhaJanela");
}

function openEditorTexto(usuarioId, arquivoId, gedId, token, tokenRenovacao, tokenServiceLayer) {
    window.open("http://www.harpaweb.com.br:7683/default?empresaId=" + usuarioId + "&&gedId=" + gedId + "&&arquivoId=" + arquivoId + "&&tk=" + token + "&&tkrn="  + tokenRenovacao + "&&tksl=" + tokenServiceLayer, "minha janela");
}

function openEditorVazio(empresaId, token, tokenRenovacao, tokenServiceLayer) {
    window.open("http://www.harpaweb.com.br:7683/default?empresaId=" + empresaId + "&&tk="+token + "&&tkrn="  + tokenRenovacao + "&&tksl=" + tokenServiceLayer, "minha janela");
}

function openEditorModoCadastroModeloDocumentos(empresaId, token, tokenRenovacao, modeloDocumentoId, tokenServiceLayer, modulo) {
    window.open("http://www.harpaweb.com.br:7683/default?empresaId=" + empresaId + "&&tk="+token + "&&tkrn="  + tokenRenovacao + "&&modeloDocumentoId=" + modeloDocumentoId + "&&criacaoModelos=true" + "&&tksl=" + tokenServiceLayer + "&&tipoCadastro=" + (modulo === '1' ? "P" : "C"), "minha janela");
}

function openEditorModoCadastroNovoArquivo(empresaId, token, tokenRenovacao, modeloDocumentoId, contratoId, tokenServiceLayer, modulo) {
    window.open("http://www.harpaweb.com.br:7683/default?empresaId=" + empresaId + "&&tk="+token + "&&tkrn="  + tokenRenovacao + "&&modeloDocumentoId=" + modeloDocumentoId + "&&contratoId=" + contratoId + "&&tksl=" + tokenServiceLayer + "&&tipoCadastro=" + (modulo === '1' ? "P" : "C"), "minha janela");
}